var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['cars', { 'cars_fix-layout': _vm.fixLayout }]},_vm._l((_vm.cars),function(car,index){return _c('Car',{key:`car-${index}`,staticClass:"cars__car",attrs:{"car":car,"tabindex":"0"},on:{"select":function($event){return _vm.$emit('select', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }